import { ISetPaymentAccountVerified, setPaymentAccountVerified } from '../api/withdraw';

import { useMutation, UseMutationResult } from 'react-query';
import { QueryKeys } from '../constants';

import { TVoidAxios } from '../types/TVoidAxios';
import { AxiosError } from 'axios';

export function useSetPaymentAccountVerified(): UseMutationResult<TVoidAxios, AxiosError, ISetPaymentAccountVerified> {
    return useMutation([QueryKeys.setPaymentAccountVerified], (params: ISetPaymentAccountVerified) =>
        setPaymentAccountVerified(params)
    );
}
